import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { unescapeHtml } from '@ecp/common/src/utils/htmlUtil';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Popup from '@ecp/common/src/components/modal/bo/Popup';

import { yyyyMMddHHmmssToOtherFormat } from '@bo-utils/dateUtils';
import { getCoNotificationDetail } from '@bo-apis/co/customerService/coNotificationApi';
import FormField from '@bo-components/common/form/FormField';
import Form from '@bo-components/common/form/Form';

const CoNoticePopup = ({ open, onClose, noticeSeq, isCO }) => {
  const [form, setForm] = useState({});

  useEffect(() => {
    if (open) {
      getCoNotificationDetail(noticeSeq).then(({ result }) => setForm(result));
    }
  }, [open, noticeSeq, isCO]);

  const fromDate = useMemo(() => {
    if (!form.fromDateTime) return '';

    return yyyyMMddHHmmssToOtherFormat(form.fromDateTime, 'yyyy-MM-dd HH:mm');
  }, [form.fromDateTime]);

  const handleClose = () => {
    setForm({});
    onClose();
  };

  return (
    <Popup
      type={'Large'}
      open={open}
      header={'공지사항'}
      onConfirmClick={handleClose}
      onClose={handleClose}
      onCancelClick={handleClose}
      confirmButtonText={'닫기'}
      useCancelButton={false}
    >
      <Form>
        <FormField label={'공지번호'}>
          <TextBox>{form.notificationNumber}</TextBox>
        </FormField>
        <FormField label={'등록일시'}>
          <TextBox>{fromDate}</TextBox>
        </FormField>
        <FormField label={'제목'} full>
          <TextBox>{form.title}</TextBox>
        </FormField>
        <FormField label={'내용'} full valueStyle={{ minHeight: '482px' }}>
          <div dangerouslySetInnerHTML={{ __html: unescapeHtml(form.content) }} />
        </FormField>
      </Form>
    </Popup>
  );
};

export default CoNoticePopup;

CoNoticePopup.propTypes = {
  open: PropTypes.bool,
  isCO: PropTypes.bool,
  onClose: PropTypes.func,
  noticeSeq: PropTypes.string,
};
